import { createFileRoute } from '@tanstack/react-router';

import { ChartsDetailsPage } from '@/areas/market-insights/MarketInsights/pages/ChartsDetailsPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page.
export const Route = createFileRoute('/_authenticated/monitoring/charts/$chartId')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ChartsDetailsPage {...pathParams} />;
}
